import { defineStore } from 'pinia';

export interface StoryContent {
  [key: string]: any;
}

interface StoryblokState {
  stories: Record<string, StoryContent | null>;
  isLoading: boolean;
}

/**
 * Static Djust data store — replaces Storyblok CMS.
 * All content is hardcoded with generic Djust branding.
 */
const DJUST_STATIC_DATA: Record<string, StoryContent> = {
  logo: {
    image: {
      filename: '/logo.svg',
      alt: 'Djust',
    },
  },
  header: {
    email: 'contact@djust.io',
    phone: '+33 1 00 00 00 00',
    name: 'Djust',
  },
  footer: {
    Commandes: [
      { title: 'Passer une commande', link: { url: '/' } },
      { title: 'Suivi de commande', link: { url: '/account/orders' } },
    ],
    Informations: [
      { title: 'Conditions générales', link: { url: '#' } },
      { title: 'Politique de confidentialité', link: { url: '#' } },
    ],
    NousContacter: [
      {
        email: 'contact@djust.io',
        phone: '+33 1 00 00 00 00',
      },
    ],
    BottomBar: [
      {
        image: { filename: '/logo.svg', alt: 'Djust' },
        adresse: '<p>Djust SAS — Paris, France</p>',
        socialMedia: [],
      },
    ],
  },
  faq: {
    title: 'FAQ',
    faqs: [],
  },
  services: {
    body: [],
  },
  home: {
    body: [],
  },
  'cart-page': {
    info: '',
  },
};

export const useStoryblokStore = defineStore('storyblokStore', {
  state: (): StoryblokState => ({
    stories: { ...DJUST_STATIC_DATA },
    isLoading: false,
  }),

  getters: {
    getStoryByName:
      (state) =>
      (name: string): StoryContent | null => {
        return state.stories[name] || null;
      },
  },

  actions: {
    setStory(name: string, data: StoryContent) {
      this.stories[name] = data;
    },

    async fetchMultipleStories(_storyNames: string[]) {
      // No-op: all data is static
    },

    async fetchStory(_storyName: string) {
      // No-op: all data is static
    },
  },
});
